import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Button from "../../../components/atoms/button/button"
import GenericModal from "../../../components/modals/generic-modal/generic-modal"
import { siteUrl } from "../../../utils/siteUrl"
import LogoMini from "../../../assets/images/logo/logo-mini.svg"
import "./register-success.scss"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"

const RegisterSuccess = props => {
 
  
  const [isFreeSamples, setIsFreeSamples] = useState(false)
  var homeLink = siteUrl + "/"
  var redireccion = homeLink + 'v-confident/muestra-gratis/'
  const activityRedirect = () => {
    if(isFreeSamples) {
      localStorage.removeItem('isFromVConfident')
      localStorage.setItem('openModalLogin', true)
    }
    window.location.href = isFreeSamples ? redireccion : props.urlActivity ? `${siteUrl}/${props.urlActivity}` : homeLink   
    localStorage.removeItem('PREV_PARAMS')   
  }

  const registerStepDatalayer = ({ category, label }) => {
    pushDataLayerEvent({
      event: "Interacciones - Registro",
      category,
      action: "click",
      label,
      Location: window.location.href,
    })
  }

  useEffect(() => {
    setIsFreeSamples(localStorage.getItem("isFromVConfident") || false)
  }, [])

  return (
    <GenericModal>
      <div className="f-modal-info">
        <div className="f-main-title-container">
          <label className="f-main-title">¡Registro exitoso!</label>
        </div>
        <div className="f-sub-title-container-generic">
          <label className="f-sub-title">AHORA HACES PARTE DE</label>
        </div>
        <img className="f-img-into-text" src={LogoMini} alt="logo-nosotras" />
        <div className="f-description-container">
          <p className="f-description">
            {  isFreeSamples ?
                 "Termina el proceso de solicitud de tu Kit de V Confident iniciando sesión a continuación"
              :  "Inicia sesión con los datos que registraste anteriormente y comienza a disfrutar del mundo de Nosotras."
            }
          </p>
        </div>

        <div className="f-btn-container">
          <div className="f-btn-interaction-container">
            <a 
              onClick={()=> {
                registerStepDatalayer({ category: "registro_exitoso", label: "Aceptar" })
                activityRedirect()
              }}
              href={isFreeSamples ? redireccion : props.urlActivity ? `${siteUrl}/${props.urlActivity}` : homeLink}
            >
              <Button title="Aceptar" className="primary-pink" />
            </a>
          </div>
        </div>
      </div>

      <a onClick={activityRedirect} href={isFreeSamples ? redireccion : props.urlActivity ? `${siteUrl}/${props.urlActivity}` : homeLink}>
        <span className="icon2-close f-icon f-close-icon"></span>
      </a>
    </GenericModal>
  )
}

export default RegisterSuccess
